import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoardingIndicatorNotBoarded = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1 9.07875C1 9.34397 1.10536 9.59832 1.29289 9.78586C1.48043 9.97339 1.73478 10.0788 2 10.0788H12.188C12.4532 10.0788 12.7076 9.97339 12.8951 9.78586C13.0826 9.59832 13.188 9.34397 13.188 9.07875V7.23875C12.7842 7.1288 12.4278 6.88909 12.1738 6.55658C11.9197 6.22407 11.782 5.81722 11.782 5.39875C11.782 4.98028 11.9197 4.57343 12.1738 4.24092C12.4278 3.90841 12.7842 3.6687 13.188 3.55875V1.71875C13.188 1.45353 13.0826 1.19918 12.8951 1.01164C12.7076 0.824107 12.4532 0.71875 12.188 0.71875H2C1.73478 0.71875 1.48043 0.824107 1.29289 1.01164C1.10536 1.19918 1 1.45353 1 1.71875V3.55475C1.4072 3.6621 1.76742 3.90121 2.02446 4.23479C2.28149 4.56836 2.42088 4.97763 2.42088 5.39875C2.42088 5.81987 2.28149 6.22914 2.02446 6.56271C1.76742 6.89629 1.4072 7.1354 1 7.24275V9.07875ZM9.204 0.72675V2.36675V0.72675ZM9.204 4.57875V6.21875V4.57875ZM9.204 8.43875V10.0788V8.43875Z",
			fill: "#DD2E44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.204 0.72675V2.36675M9.204 4.57875V6.21875M9.204 8.43875V10.0788M1 9.07875C1 9.34397 1.10536 9.59832 1.29289 9.78586C1.48043 9.97339 1.73478 10.0788 2 10.0788H12.188C12.4532 10.0788 12.7076 9.97339 12.8951 9.78586C13.0826 9.59832 13.188 9.34397 13.188 9.07875V7.23875C12.7842 7.1288 12.4278 6.88909 12.1738 6.55658C11.9197 6.22407 11.782 5.81722 11.782 5.39875C11.782 4.98028 11.9197 4.57343 12.1738 4.24092C12.4278 3.90841 12.7842 3.6687 13.188 3.55875V1.71875C13.188 1.45353 13.0826 1.19918 12.8951 1.01164C12.7076 0.824107 12.4532 0.71875 12.188 0.71875H2C1.73478 0.71875 1.48043 0.824107 1.29289 1.01164C1.10536 1.19918 1 1.45353 1 1.71875V3.55475C1.4072 3.6621 1.76742 3.90121 2.02446 4.23479C2.28149 4.56836 2.42088 4.97763 2.42088 5.39875C2.42088 5.81987 2.28149 6.22914 2.02446 6.56271C1.76742 6.89629 1.4072 7.1354 1 7.24275V9.07875Z",
			stroke: "#9B0000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgBoardingIndicatorNotBoarded);
export { ForwardRef as ReactComponent };
